import { Component, Input, OnInit } from "@angular/core";
import { AnexoTO } from "src/app/data/schema/Courses/AnexoTO";

@Component({
    selector: "app-attachment-audio",
    templateUrl: "./attachment-audio.component.html",
    styleUrls: ["./attachment-audio.component.scss"]
})
export class AttachmentAudioComponent implements OnInit {
    @Input("attachment")
    public attachment!: AnexoTO;

    constructor() {}

    ngOnInit() {}
}
